import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../../../colorVars';
import { addExitTactic } from '../../../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/addExitTactic';
import { useWebsocketStore } from '../../../../../../../../../../../stores/websocketStore/websocketProvider';
import { CancelOrderButton } from '../../../../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import IncrementButton from '../../../../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import TextButton from '../../../../../../../../../../atomic/buttons/textButton/TextButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import {
  Body3,
  fontSizes,
} from '../../../../../../../../../../atomic/text/Text';
import { breakPriceValidation } from '../../../../../../../../../../forms/tradeplans/AddTradePlan/DataValidation';
import style from '../IndividualAddTacticPanel.module.css';
import { AddBreakPriceHeader } from './AddBreakPriceHeader';

export const AddBreakPriceTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, softOrderId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const [newPriceInput, setNewPriceInput] = useState(0);
    const [priceArray, setPriceArray] = useState([]);
    const [headerText, setHeaderText] = useState('Add Underlying Break Price');
    const [headerTextColor, setHeaderTextColor] = useState(colors.lightGrey);
    const timeoutRef = useRef(null);
    const details = {
      prices: priceArray,
    };
    const addTactic = () => {
      const validationResult = breakPriceValidation(details);
      if (validationResult[0] === false) {
        setHeaderText(validationResult[1]);
        setHeaderTextColor(colors.red);
        const timer = setTimeout(() => {
          setHeaderText('Add Underlying Break Price');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      } else {
        addExitTactic(tradePlanId, {
          tactic: 'BREAK_PRICE',
          details,
        });
        setHeaderText('Underlying Break Price Added');
        setHeaderTextColor(colors.green);
        const timer = setTimeout(() => {
          setHeaderText('Add Underlying Break Price');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      }
    };

    useEffect(() => {
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    }, []);

    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <AddBreakPriceHeader />
            <tbody>
              {priceArray.map((price, index) => {
                return (
                  <tr key={price}>
                    <td className={style.labelTd}>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        {`Price ${index + 1}`}
                      </Body3>
                    </td>
                    <td className={style.labelTd}>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        ${price}
                      </Body3>
                    </td>
                    <td className={style.inputTd}>
                      <div className={style.inputWrapper}>
                        <CancelOrderButton
                          width={15}
                          margin="5px 0 0 0"
                          clickHandler={() => {
                            const filteredArray = [...priceArray].filter(
                              (price, i) => i !== index
                            );
                            setPriceArray(filteredArray);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Add
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableFieldNoOnBlurUpdate
                      inputType="number"
                      fontSize={fontSizes.body3}
                      value={newPriceInput}
                      setValue={(newValue) => setNewPriceInput(newValue)}
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </div>
                </td>
                <td className={style.labelTd}>
                  <div className={style.inputWrapper}>
                    <IncrementButton
                      color={colors.white}
                      backgroundColor={colors.blue}
                      width={10}
                      stroke={1}
                      handleClick={() => {
                        setPriceArray((prev) => [...prev, newPriceInput]);
                      }}
                      paddingPercent={10}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <header className={style.header}>
            <Body3 color={headerTextColor} fontWeight={700}>
              {headerText}
            </Body3>
            <TextButton
              width="20%"
              disabled={tradePlan.exitTactics['BREAK_PRICE'] ? true : false}
              color={colors.lightGrey}
              backgroundColor={
                tradePlan.exitTactics['BREAK_PRICE'] ? colors.grey : colors.blue
              }
              fontSize="small"
              clickHandler={addTactic}
            >
              Add
            </TextButton>
          </header>
        </div>
      </TabPanel>
    );
  }
);

AddBreakPriceTacticPanel.tabsRole = 'TabPanel';
